<template>
  <div>
    <div v-if="data && data.length">
      <div class="item-contact text-blue mb-4 d-flex justify-content-between" v-for="(item, index) in data" :key="`contact-list-${index}`" @click="submit(item)">
        <span> <v-icon class="text-blue">mdi-file-document-edit-outline</v-icon><v-icon class="text-blue">mdi-house-outline</v-icon>{{ type == "contact" ? " เลขที่สัญญา" : "" }} {{ item }} </span>
        <!-- <span
          ><v-btn outlined icon color="#23409a" x-small
            ><span class="fs-17" style="margin-left: 3px;"><v-img style="width:9px;height:auto" src="@/assets/vector.svg"></v-img></span></v-btn
        ></span> -->
      </div>
    </div>
    <div v-else>ไม่มีข้อมูลในระบบ</div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      default: "contact", //contact //address
      type: String,
    },
    data: {
      default: [], //contact //address
      type: Array,
    },
  },
  computed: {},
  methods: {
    submit(item) {
      this.$store.dispatch("setContact", item);
      this.$emit("select-contact", item);
    },
  },
};
</script>
